<template>
  <div class="select-year-champion" :class="{ 'option-f': headType === '2' }">
    <el-select
      :popper-append-to-body="false"
      :no-data-text="$t('home.nodata')"
      v-model="yearvalue"
      :placeholder="$t('schedule.select')"
      @change="toChampion"
    >
      <el-option
        v-for="(item, index) in yearVal"
        :key="index"
        :label="item.label"
        :value="item.value"
      >
        <p class="team-name" @click="change(item)">
          {{ item.label }}
        </p>
      </el-option>
    </el-select>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      yearvalue: localStorage.getItem('currentYear') || "2023-2024",
      yearList: [{ label: "2021-2022", value: "2021" }],
      boy_yearList: [
        {
          label: "2023-2024",
          value: "2024"
        },
        {
          label: "2022-2023",
          value: "2023"
        },
        {
          label: "2021-2022",
          value: "2022"
        },
        {
          label: "2020-2021",
          value: "2021"
        }
      ],
      girl_yearList: [
        {
          label: "2023-2024",
          value: "2024"
        },
        {
          label: "2022-2023",
          value: "2023"
        }
      ]
    };
  },
  methods: {
    toChampion(evt) {
      switch (evt) {
        case "2024":
          this.$router.push({
            path: "/champion_challenge",
            query: { type: this.headType }
          });
          // this.yearvalue = "2023-2024";
        break;
        case "2023":
          this.$router.push({
            path: "/champion_challenge_2023",
            query: { type: this.headType }
          });
          // this.yearvalue = "2022-2023";
          break;
        case "2022":
          // push to champion_challenge_2022
          this.$router.push({
            path: "/champion_challenge_2022",
            query: { type: this.headType }
          });
          // this.yearvalue = "2021-2022";
          break;
        case "2021":
          this.$router.push({
            path: "/champion_challenge_2021",
            query: { type: this.headType }
          });
          // this.yearvalue = "2020-2021";
          break;
        default:
          break;
      }
    },
    change(item) {
      localStorage.setItem("currentYear", item.label)
    },
  },
  computed: {
    ...mapState(["headType"]),
    yearVal() {
      if (this.headType == "1") {
        return this.boy_yearList;
      } else {
        return this.girl_yearList;
      }
    }
  }
};
</script>
<style>
.select-year-champion {
  width: max-content;
  margin-left: auto;
  margin-block: 20px;
}
</style>
